import { get } from 'lodash'
import * as schemaFetcherV2 from '@wix/wix-data-client-common/dist/esm/business-logic/collections/schemaFetcherV2'
import { getDPCollectionId } from '../utils/getDPCollectionId'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { PageRef, RouterRef } from '@wix/editor-platform-sdk-types'
import type { EditorOriginToBI } from '@wix/wix-data-client-common'
import { EDITOR_ORIGIN_TO_BI } from '@wix/wix-data-client-common'

const getCollectionByPageRef = async ({
  editorSdkProxy,
  collectionsApi,
  routerRef,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
  routerRef: RouterRef
  pageRef: PageRef
}) => {
  const collectionId = await getDPCollectionId({
    editorSdkProxy,
    routerRef,
    pageRef,
  })

  const collection = collectionId
    ? await schemaFetcherV2.fetch(collectionsApi, collectionId)
    : undefined

  return collection
}

type Params = {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
  pageRef: PageRef
  routerRef: RouterRef
  origin: EditorOriginToBI
  panelName: string
}

export const getBiDefaults = async ({
  editorSdkProxy,
  collectionsApi,
  pageRef,
  routerRef,
  origin,
  panelName,
}: Params) => {
  const collection = await getCollectionByPageRef({
    editorSdkProxy,
    collectionsApi,
    routerRef,
    pageRef,
  })
  return {
    pageId: pageRef.id,
    panel_name: panelName,
    origin: EDITOR_ORIGIN_TO_BI[origin],
    collection_id: get(collection, 'id', null),
    collection_name: get(collection, 'displayName', null),
  }
}
